export default class Translator
{
    constructor()
    {
        this.lang = this.getLang()
        this.setTranslations()
    }

    getLang()
    {
        const defaultLang = 'it'
        let tmpLang = defaultLang
        try
        {
            const urlString = window.location.href
            const url = new URL(urlString)
            tmpLang = url.searchParams.get('lang')
        }
        catch
        {
            tmpLang = defaultLang
        }
        if(tmpLang === undefined || tmpLang === null || tmpLang === '') tmpLang = defaultLang

        return tmpLang.toLocaleLowerCase()
    }

    setTranslations()
    {
        const translatableElements = document.querySelectorAll('[data-translate]')
        translatableElements.forEach(el =>
        {
            const field = el.dataset.translate
            const translation = Translations[field]
            if(translation)
            {
                el.innerHTML = translation[this.lang] + el.innerHTML

                const urlField = `${this.lang}Url`
                if(urlField in translation)
                {
                    el.href = translation[urlField]
                }
            }
        })
    }

    localizePermalink(permalink)
    {
        if(this.lang === undefined || this.lang === 'it') return permalink
        return permalink.replace('3dwine.bbsway.it/', `3dwine.bbsway.it/${this.lang}/`)
    }
}

export class Translations
{
    static home_title_1 = {
        it: 'La natura non ha fretta',
        en: 'nature is in no hurry'
    }
    static home_title_2 = {
        it: 'eppure tutto si realizza',
        en: 'and yet everything comes true'
    }
    static findmore = {
        it: 'Scopri',
        en: 'Find more'
    }
    static wines = {
        it: 'Vini ',
        en: 'Wines '
    }
    static grapes = {
        it: 'Uve ',
        en: 'Grapes '
    }
    static home = {
        it: 'Home',
        en: 'Home',
        itUrl: 'https://3dwine.bbsway.it/',
        enUrl: 'https://3dwine.bbsway.it/en/'
    }
    static project = {
        it: 'Il Nostro Progetto',
        en: 'Our Project',
        itUrl: 'https://3dwine.bbsway.it/il-nostro-progetto/',
        enUrl: 'https://3dwine.bbsway.it/en/our-project/'
    }
    static senses = {
        it: 'Cinque Sensi',
        en: 'Five Senses',
        itUrl: 'https://3dwine.bbsway.it/cinque-sensi/',
        enUrl: 'https://3dwine.bbsway.it/en/five-senses/'
    }
    static magazine = {
        it: 'Magazine',
        en: 'Magazine',
        itUrl: 'https://3dwine.bbsway.it/magazine/',
        enUrl: 'https://3dwine.bbsway.it/en/magazine/'
    }
}